import {useState} from "react";
import {FaAnglesRight} from "react-icons/fa6";
import {FiChevronDown, FiChevronUp} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";

export const ActiveDirectoryHint = () => {
  const [active, setActive] = useState<boolean>(false);
  return (
    <div className="row">
      <div className="col-12 d-flex flex-row">
        <span className="pulseTextBodyBold">Additional help for:</span>
        <a
          className="pulseTextBody ms-2 mb-0 pb-0 text-decoration-none"
          data-bs-toggle="collapse"
          href="#activeDirectoryInfo"
          role="button"
          aria-expanded="false"
          onClick={() => setActive(!active)}
          aria-controls="collapseExample"
        >
          ActiveDirectory{" "}
          <Icon icon={active ? FiChevronUp : FiChevronDown} display={"inline"} className={"pulse-color-gray-900"} />
        </a>
      </div>
      <div className="collapse col-12" id="activeDirectoryInfo">
        <div className="card card-body mt-4 mb-2">
          <div className="pulseTextH3 mb-2">ActiveDirectory Setup Tips</div>
          <ol className="pulseTextBodySmall">
            <li>
              Download the Uptime.com Service Provider SAML Metadata from the link near the top of the page, and import
              it into ActiveDirectory.
            </li>
            <li>Edit the Claim Rules for Uptime.com and add a new rule.</li>
            <li>
              Map the following LDAP attributes to outgoing claim types:
              <ol>
                <li>
                  E-Mail-Addresses <Icon icon={FaAnglesRight} display={"inline"} />
                  Name ID
                </li>
                <li>
                  E-Mail-Addresses <Icon icon={FaAnglesRight} display={"inline"} />
                  E-Mail Address
                </li>
                <li>
                  Given-Name <Icon icon={FaAnglesRight} display={"inline"} />
                  Given Name
                </li>
                <li>
                  Surname <Icon icon={FaAnglesRight} display={"inline"} />
                  Surname
                </li>
              </ol>
            </li>
            <li>Fill in the Uptime.com SSO Setup form below with the appropriate ActiveDirectory details.</li>
          </ol>
        </div>
      </div>
    </div>
  );
};
